import { TopBar } from 'admin-features/settings/components/TopBar/TopBar';
import { ReactNode } from 'react';

import { useResponsive } from 'shared/hooks/useResponsive';

import {
  Centered,
  Container,
  Content,
  Header,
  Layout,
  MobileBottomMenu,
  MobileContainer,
  MobileHeader,
  MobileLayout,
  Sidebar,
} from './PageLayout.styles';
import { PoweredBy } from './PoweredBy';

export interface PageLayoutProps {
  content?: ReactNode;
  sidebar?: ReactNode;
  header?: ReactNode;
  bottomMenu?: ReactNode;
  drawerOpen?: boolean;
  drawerOpenWidth?: string | number;
  drawerClosedWidth?: string | number;
}

export function PageLayout({
  content,
  header,
  sidebar,
  bottomMenu,
  drawerOpen,
  drawerOpenWidth,
  drawerClosedWidth,
}: PageLayoutProps) {
  const { isMobile } = useResponsive();

  if (isMobile) {
    return (
      <MobileContainer>
        <MobileHeader>
          <TopBar />
          {header}
        </MobileHeader>

        <MobileLayout>
          <Content>{content}</Content>

          {sidebar}
        </MobileLayout>

        <MobileBottomMenu>{bottomMenu}</MobileBottomMenu>
      </MobileContainer>
    );
  }

  return (
    <Container>
      <TopBar />

      <Layout sidebarWidth={drawerOpen ? drawerOpenWidth : drawerClosedWidth}>
        <Sidebar>{sidebar}</Sidebar>

        <Centered>
          <Header>{header}</Header>
          <Content>{content}</Content>
        </Centered>
      </Layout>

      <PoweredBy />
    </Container>
  );
}
